function updateDeliveryTimer() {
  const now = new Date();
  const cutoff = new Date();
  cutoff.setHours(23, 59, 59, 0); // heure limite d'expédition : 23h59

  const diff = cutoff - now;

  if (diff <= 0) {
    document.querySelector('.delivery-timer').textContent = "00 h 00 min 00 s";
    return;
  }

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  document.querySelector('.delivery-timer').textContent = 
    `${hours} h ${minutes < 10 ? '0' + minutes : minutes} min ${seconds < 10 ? '0' + seconds : seconds} s`;
}

document.addEventListener('DOMContentLoaded', () => {
  updateDeliveryTimer();
  setInterval(updateDeliveryTimer, 1000); // met à jour chaque seconde
});
